import { render } from "./DishDetailsPage.vue?vue&type=template&id=679f0e4f&ts=true"
import script from "./DishDetailsPage.vue?vue&type=script&lang=ts"
export * from "./DishDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__